"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKey = void 0;
function createKey() {
    return new Date().toISOString() + '/' + Math.random();
}
exports.createKey = createKey;
//# sourceMappingURL=storage-strategy.js.map